import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import {
  Input, Dropdown, Icon, Menu, Button, Row, Col, Spin, Select
} from 'antd';
import Tab from '../home/tab/index';
import Cards from '../home/cards/index';
import AppApplyModal from '../util/AppApplyModal';
import Portal from './Portal';
import ApplyApp from '../util/appApply/index';
import validate from '../util/appApply/validate';
import mainBanner from '../../style/img/mainBanner.png';
import cloud2 from '../../style/img/cloud2.png';
import mainWf from '../../style/img/mainWf.png';
import mainMode from '../../style/img/mainMode.png';
import mainDev from '../../style/img/mainDev.png';
import mainNStandard from '../../style/img/mainNStandard.png';
import logo from '../../style/img/logo.png';
import util from '../../util/index';
import MobileMode from '../util/Mobilemode';
import EcodeWf from './EcodeWf';
import RadioSort from '../util/RadioSort';
import EcodeLocal from '../ecodeLocal';

const { isWeaver, getAccessToken, openEcode } = util;
const isOpen = openEcode();
const {
  checkLicense,
} = validate;
const Search = Input.Search;
const Option = Select.Option;
const store = [
  'mainStore',
  'initStore',
  'homeStore',
  'themeListStore',
  'modeListStore',
  'listStore',
  'ecodeWfStore',
  'caseListStore',
];

function getParamById(id) {
  let href = window.location.href;
  const reg = new RegExp(`${id}\=[^\&^\#^\/^\:]+`);
  return href.match(reg) ? href.match(reg)[0].split('=')[1] : "";
}
@inject(...store)
@observer
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'main',
  }
  constructor(props) {
    super(props);
    this.state = {
      menuStyle: {
        borderRadius: 5, marginLeft: -20, textAlign: 'center'
      },
      date: '',
    }
  }

  componentDidMount() {
    const {
      homeStore: { getAppHot, setType, callCategoryData, getLastestShare, doInitApplyModal, clearAppHot },
      themeListStore: { getThemeList, params, orderby },
      modeListStore: { getModeList, getMould },
      mainStore: { setMobxState, init },
      location: { query },
    } = this.props;
    init();
    clearAppHot();
    doInitApplyModal();
    setType('all', '全部应用');
    getThemeList({ current: 1, pageSize: 8, orderby });
  }

  componentWillUnmount() {
    const { mainStore: { setMobxState } } = this.props;
    setMobxState({ visibleApply: false, orderby: 'createdate' });
  }
  onMenuClick = (key, name, go = true) => {
    const { homeStore, mainStore: { setMobxState, routing }, location: { query }, listStore: { setSearchValue }, } = this.props;
    setMobxState({ type: { key, name }, visibleNav: false });
    setSearchValue('');
    homeStore.setType(key, name);
    if(key === 'workflowStyle' || key === 'workflowChart') {
      routing.push({
        pathname: '/app/workflow',
        query: {
          ...query,
          id: 'workflow',
          type: key,
        }
      })
      return;
    }
    if (go) this.getMore(key);
  }

  exit = () => {
    const { initStore: { exit } } = this.props;
    localStorage.removeItem('me');
    exit();
    this.setState({ date: new Date() });//用于强制刷新页面
  }
  openForm = (item, type) => {
    const { modeListStore: { getAppDetail }, homeStore: { view } } = this.props;
    if (type === 'mode' || type === 'dev' || type === 'nStandard') {
      getAppDetail({ id: item.sw_id }).then((data) => {
        view(data.app);
        // window.open('http://203.110.166.60:8088/login/login4wf.jsp?userid=1&gopage=' +
        // `/cloudstore/system/index.jsp#/${data.app.s_number}/set`);
      });
      } else {
      window.open("http://203.110.166.54:8085/login/login4wf.jsp?userid=1&showbtn=0&gopage=/workflow/request/AddRequest.jsp?workflowid=" + item.s_wfid);
    }
  }
  onClick = (item, isApp, typeParams) => {
    const { mainStore: { routing }, homeStore: { setType } } = this.props;
    if (isApp) {
      routing.push(`/app/appDetail/${item.sw_id}`);
      setType(typeParams.id, typeParams.name);
    } else {
      window.open("http://203.110.166.54:8085/login/login4wf.jsp?userid=1&showbtn=0&gopage=/workflow/request/AddRequest.jsp?workflowid=" + item.s_wfid);
    }
  }
  onCollect = (item, type) => {
    const { homeStore } = this.props;
    homeStore.callCollect({ s_ids: item.sw_id }, type, item.tms_iscoll === '1' ? 'collect' : 'remove');
  }
  onApply = (item) => {
    const { homeStore } = this.props;
    homeStore.callApply({ sw_id: item.sw_id, s_id: item.s_id }, [{ appId: item.s_number, appName: item.s_name }]);
  }
  collect = (item, type) => {
    const { mainStore: { setMobxState }, modeListStore: { getMould, getModeList, callCollect } } = this.props;
    callCollect({ collect: item.tms_iscoll === '1' ? '0' : '1', s_ids: item.sw_id }).then(data => {
      getModeList({ current: 1, pageSize: 6, module: getMould(type) }).then((data) => {
        let nState = {};
        nState[`${type}List`] = data.apps;
        setMobxState(nState);
      });
    });
  }
  apply = (item, type) => {
    const { mainStore: { setMobxState }, modeListStore: { getAppDetail } } = this.props;
    getAppDetail({ id: item.sw_id }).then(() => {
      setMobxState({ visibleApply: true, applyType: type });
    });
  }
  onFormChange = (values, allValues) => {
    const { modeListStore: { applyLicense, setMobxState }, mainStore: { appDetail } } = this.props;
    setMobxState({ isApply: false });
    const data = toJS(appDetail);
    if (Object.keys(values).indexOf('license') >= 0) {
      checkLicense(values.license) && applyLicense({
        sw_id: data.sw_id,
        ec_id: allValues.c_id,
        c_id: allValues.c_id,
        ecname: allValues.c_name,
        license: values.license,
      });
    }
  }
  goOrder = () => {
    const { mainStore: { applyType } } = this.props;
    window.open(`${window.server}/manager#/app/order?id=${applyType}`, '_blank');
  }
  getMore = (id) => {
    const { mainStore: { routing }, location: { query } } = this.props;
    routing.push({
      pathname: id === 'workflowChart' ? '/app/workflow' : '/app',
      query: {
        ...query,
        id: id,
      }
    });
    window.scrollTo(0, 0);
  }
  bbsSso = () => {
    const { initStore: { getSso } } = this.props;
    this.setState({ moduleVisible: false })
    getSso().then((data) => data.data ? window.open(`http://test.e-cloudstore.com.cn/bbs/#/home?userKey=${data.data}`) : window.open(`http://test.e-cloudstore.com.cn/bbs/#/home`));
  }
  search = () => {
    const { mainStore: { routing }, location: { query }, listStore: { setMobxState } } = this.props;
    routing.push({
      pathname: '/app',
      query: {
        ...query,
        id: 'all',
      }
    })
    this.allAppCallApis();
  }
  allAppCallApis = () => {
    const {
      listStore: { params: { searchValue }, setMobxState: listSetMobxState },
    } = this.props;
    listSetMobxState({searchValueInfo: searchValue});
  }

  onChange = value => {
    const { themeListStore: { params, setState, getThemeList } } = this.props;
    setState({ orderby: value });
    getThemeList({ current: 1, pageSize: 8, orderby: value });
  }
  openFlash = (e, v) => {
    const href = v === "e8" ? 'https://e-cloudstore.com/old#/app/120be848-3ef3-4ec7-bdf6-a13100d14dbd/show' : 'https://e-cloudstore.com/old#/app/9e43b724-85aa-4d8e-9214-0f188c0025fd/show';
    window.open(href);
    // e.stopPropagation && e.stopPropagation();
    // e.preventDefault && e.preventDefault();
    // e.nativeEvent && e.nativeEvent.preventDefault();
  }
  render() {
    let docId = window.location.href.indexOf('docId=') > 0 ? getParamById("docId") : '';
    if(docId) return null;
    let { me } = this.props.initStore;
    const { query } = this.props.location;
    //--------------------------------------登录-----------------------------------------------------//
    me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
    const isLogin = (me && null !== me.com && "" !== me.com && me.member && null !== me.member.m_name) ? true : false;
    //--------------------------------------------------------------------------------------------------//
    const { menuStyle } = this.state;
    const isweaver = isWeaver();
    const menu = (
      <Menu style={menuStyle}>
        <Menu.Item><a onClick={() => this.onMenuClick('all', '全部应用')}>全部应用</a></Menu.Item>
        <Menu.Item><a onClick={() => this.onMenuClick('workflowChart', '流程表单')}>流程表单</a></Menu.Item>
        <Menu.Item><a onClick={() => this.onMenuClick('theme', '门户主题')}>门户主题</a></Menu.Item>
        <Menu.Item><a onClick={() => this.onMenuClick('case', '开发案例')}>开发案例</a></Menu.Item>
        <Menu.Item key="app"><a onClick={() => this.onMenuClick('app', '开发应用')}>开发应用</a></Menu.Item>
        <Menu.Item key="old"><a onClick={() => window.location.href = "/old"}>E8 应用</a></Menu.Item>
        <Menu.Item><a><MobileMode>建模构建库</MobileMode></a></Menu.Item>
        <Menu.Item key="mode"><a onClick={() => this.onMenuClick('mode', 'E9建模模板')}>E9建模模板</a></Menu.Item>
        <Menu.Item key="docViewTemplate"><a onClick={() => this.onMenuClick('docViewTemplate', '文档显示模板')}>文档显示模板</a></Menu.Item>
        {
          query.bbsSso === "true" ?
            [<Menu.Item><a onClick={this.bbsSso}>云商店论坛</a></Menu.Item>] : null
        }
      </Menu>
    );
    const { prefixCls, homeStore, listStore: { setSearchValue }, mainStore: { routing, visibleNav, setMobxState, visibleApply } } = this.props;
    let {
      homeStore: { appHot, applyModal, applyApps, type },
      mainStore: { devList, modeList, nStandardList },
      themeListStore: { themeList, orderby },
    } = this.props;
    appHot = toJS(appHot);
    applyModal = toJS(applyModal);
    applyApps = toJS(applyApps);
    devList = toJS(devList);
    modeList = toJS(modeList);
    nStandardList = toJS(nStandardList);
    themeList = toJS(themeList);
    const allCount = appHot.length + themeList.length + modeList.length + devList.length + nStandardList.length;
    const sortList = [{
      label:  <span>
                最新
                <svg className="icon-font sort-btn-icon" aria-hidden="true">
                  <use href="#icon-Down-"></use>
                </svg>
              </span>,
      value: 'createdate',
    }, {
      label:  <span>
                最热
                <svg className="icon-font sort-btn-icon" aria-hidden="true">
                  <use href="#icon-Down-"></use>
                </svg>
              </span>,
      value: 'downloadcounts',
    }, {
      label:  <span>
                访问量
                <svg className="icon-font sort-btn-icon" aria-hidden="true">
                  <use href="#icon-Down-"></use>
                </svg>
              </span>,
      value: 'visits',
    }];
    return (
      <div className={prefixCls} ref={(el) => this.Main = el}>
        <div className={`${prefixCls}-header`}>
          <div className={`${prefixCls}-header-nav`}>
            <div className={`${prefixCls}-header-nav-logo`}>
              <img src={cloud2} alt="" />
              <span>云商店</span>
            </div>
            <Search
              style={{ width: 140 }}
              onChange={(e) => setSearchValue(e.target.value.trim())}
              onPressEnter={this.search}
              onSearch={this.search}
            />
            <Dropdown overlay={menu} trigger={['click']} visible={visibleNav} onVisibleChange={(vis) => setMobxState({ visibleNav: vis })}>
              <a className={`${prefixCls}-header-nav-dropdown`}>
                {type.name}<Icon type={visibleNav ? "up" : "down"} />
              </a>
            </Dropdown>
            {
              isLogin ? (
                <div className={`${prefixCls}-header-nav-login`}>
                  <span>{me && me.member && me.member.m_name}</span>
                  <span className={`${prefixCls}-header-nav-login-exit`} onClick={this.exit}>退出</span>
                  {
                    isweaver && (
                      <span className={`${prefixCls}-header-nav-toManager`} onClick={() => window.open(`${window.server}/manager#/app/order?id=workflow`)}>进入后台</span>
                    )
                  }
                </div>
              ) : (
                  <span className={`${prefixCls}-header-nav-login`} onClick={() => routing.push('/login')}>登录</span>
                )
            }
          </div>
          <div className={`${prefixCls}-header-con`}>
            <div className={`${prefixCls}-header-con-desc`}>
              <div className={`${prefixCls}-header-con-desc1`}>泛微云应用共享与服务平台</div>
              <div className={`${prefixCls}-header-con-desc2`}>打造不同行业的深度应用 提供ECOLOGY产品相关服务与支持</div>
              <div className={`${prefixCls}-header-con-desc2`}>连接客户、销售、项目、技术、客服、伙伴</div>
              <Button className={`${prefixCls}-header-con-desc-btn`} icon="arrow-down" onClick={() => window.scrollTo(0, 300)}>了解更多</Button>
              <EcodeLocal
                title="分享应用"
                buttonClassName={`${prefixCls}-header-con-desc-upload-button ${prefixCls}-header-con-desc-btn`}
                className={`${prefixCls}-header-con-desc-upload`}
                icon="arrow-up"
              />
              <Button
                className={`${prefixCls}-header-con-desc-btn`}
                style={{"marginLeft": "30px"}}
                onClick={() => window.open("https://e-cloudstore.com/old#/app/120be848-3ef3-4ec7-bdf6-a13100d14dbd/show")}
              >E8统一替换FLASH插件方案</Button>
              {/* <Select defaultValue="e8" className={`${prefixCls}-header-con-desc-select`}>
                <Option value="e8">
                  <Button className={`${prefixCls}-header-con-desc-select-btn`} onClick={e => this.openFlash(e, "e8")} >E8统一替换FLASH插件方案</Button>
                </Option>
                <Option value="e7">
                  <Button className={`${prefixCls}-header-con-desc-select-btn`} onClick={e => this.openFlash(e, "e7")} >E7统一替换FLASH插件方案</Button>
                </Option>
              </Select> */}
            </div>
            <img src={mainBanner} alt="" />
          </div>
        </div>
        <div className={`${prefixCls}-body`}>
          {allCount === 0
            && <Spin spinning={true}><div style={{ width: '100%', height: 300 }} /></Spin>}
          <EcodeWf {...this.props} getMore={() => this.getMore('workflowChart')} />
          {themeList.length > 0 && <div className={`${prefixCls}-body-con`}>
            <Tab title="门户主题" span={24} offset={0} getMore={() => this.getMore('theme')} />
            <RadioSort
              datas={sortList}
              value={orderby}
              className="main-workflow-sort"
              onChange={this.onChange}
            />
            <Portal extraCls="main-theme-list" apply={this.apply} />
          </div>}
        </div>
        <div className='home-footter'>
          <Row>
            <Col span={6} offset={5}>
              <div className='home-footter-content'>
                <img src={logo} alt='' />
              </div>
              <div className='home-footter-content'>
                <Icon type="environment-o" className='home-footer-icon' />
                <span className='home-footer-text'>上海市闵行区联航路1188号33号楼</span>
              </div>
              <div className='home-footter-content'>
                <Icon type="mail" className='home-footer-icon' />
                <span className='home-footer-text'>sales@weaver.com.cn</span>
              </div>
              <div className='home-footter-content'>
                <Icon type="phone" className='home-footer-icon' />
                <span className='home-footer-text'>021-68869298</span>
              </div>
            </Col>
            <Col span={4}>
              <div className='home-footter-content'>
                <span className='home-footter-content-main'>关于云商店</span>
              </div>
              <div className='home-footter-content'>
                <a href='https://www.e-cloudstore.com/#/?_k=s73jnm'>功能价值</a>
              </div>
              <div className='home-footter-content'>
                <a href='/' target="_blank">价格体系</a>
              </div>
              <div className='home-footter-content'>
                <a href='/' target="_blank">我们的服务</a>
              </div>
            </Col>
            <Col span={4}>
              <div className='home-footter-content'>
                <span className='home-footter-content-main'>联系我们</span>
              </div>
              <div className='home-footter-content'>
                <a href='' target="_blank">公司简介</a>
              </div>
              <div className='home-footter-content'>
                <a href='/' target="_blank">产品特性</a>
              </div>
              <div className='home-footter-content'>
                <a href='/' target="_blank">注册云商店</a>
              </div>
            </Col>
            <Col span={5}>
              <div className='home-footter-content'>
                <span className='home-footter-content-main'>关于泛微</span>
              </div>
              <div className='home-footter-content'>
                <a href='http://www.weaver.com.cn/'>泛微官网</a>
              </div>
              <div className='home-footter-content'>
                <a href='/' target="_blank">产品方案</a>
              </div>
              <div className='home-footter-content'>
                <a href='/' target="_blank">客户案例</a>
              </div>
              <div className='home-footter-content'>
                <a href='/' target="_blank">服务中心</a>
              </div>
            </Col>
          </Row>
          <div className='copy-right'>
						<p><a target="_blank" href="http://www.weaver.com.cn">版权所有：上海泛微网络科技股份有限公司</a></p>
						<p>Copyright © 2001-2021 Weaver Network All Rights Reserved.<a target="_blank" href="https://beian.miit.gov.cn">沪ICP备05040488号-11</a></p>
					</div>
        </div>
        <AppApplyModal applyModal={applyModal}
          applyApps={applyApps}
          handleCloseModal={() => {
            homeStore.setMobxState({ applyModal: { ...applyModal, visible: false } });
          }}
        />
        <ApplyApp
          visible={visibleApply}
          onChange={(v) => setMobxState({ visibleApply: v })}
          onFormChange={this.onFormChange}
          goOrder={this.goOrder}
        />
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/main/index.js